import React from 'react';
import { Divider, Space, Collapse } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import TitleWithIcon from '../common/TitleWithIcon';

const { Panel } = Collapse;

const ApplicationMessages = ({ messages = [] }) => {
  if (!messages.length) return null;

  return (
    <>
      <Divider />
      <Space direction="vertical" style={{ width: '100%' }}>
        <TitleWithIcon icon={<MailOutlined />} text="Messages" />
      </Space>

      <Collapse>
        {messages.map((message) => (
          <Panel
            header={format(new Date(message.created_at), "MMMM dd, yyyy 'at' h:mm aaa")}
            key={message.created_at}
          >
            <p>{message.message}</p>
          </Panel>
        ))}
      </Collapse>
    </>
  );
};

export default ApplicationMessages;
